// Matches the vAudit sticker format, e.g. SO-157537-01. orderNumber already carries the "SO-" prefix.
// The backend sends this as the Locus line item's scanId, which is what the rider scans at pickup.
export const buildPackageCode = (orderNumber: string, sequence: number) =>
  `${orderNumber}-${String(sequence).padStart(2, '0')}`;
